<template>
  <div id="mainOuter">
    <PageHeader/>
    <main id="main">
      <transition name="fade">
        <!-- keep-alive will keep component in memory so images etc are not reloaded -->
        <!-- <keep-alive include="['Home', 'Shop']"> -->
          <router-view/>
        <!-- </keep-alive> -->
      </transition>
    </main>
    <PageFooter/>
  </div>
</template>

<script>
import PageHeader from "../pageElements/ThePageHeader";
import PageFooter from "../pageElements/ThePageFooter";

export default {
  name: "ViewMain",
  components: {
    PageHeader,
    PageFooter
  },
  created(){
    //get reference shortly after loading website. Ensures smooth transition to shop page
    this.$store.dispatch("reference/getReference")
  }
};
</script>

<style lang="scss">

#mainOuter {
  height: 100vh;
  display: block;
  flex-direction: column;
}


#main {
  // min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
}

.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-active {
  transition: all 0.5s ease;
  transition-delay: 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

